import LineGraph from "./component";

export default LineGraph;
